import axios from 'axios';
import cfac22 from '../../cfac22';

function getBrowserLanguageCode() {
  if (typeof navigator === 'undefined') return 'pt_BR';

  const language = navigator.language || 'pt-BR';
  return language.replace('-', '_');
}

export const requestCode = async ({
  cellPhone,
  identifier,
  partnerId,
  newUser = false,
  sendType = ['whatsapp', 'sms'],
}) => {
  try {
    const endpoint = `${cfac22('MICROSERVICES')}/auth/request-code`;

    const { data } = await axios.post(
      endpoint,
      {
        cellPhone,
        identifier,
        partnerId,
        languageCode: getBrowserLanguageCode(),
        newUser,
        sendType,
      },
      {
        withCredentials: true,
        headers: {
          'Full-Url': window.location.href,
        },
      }
    );

    const { success, result, error } = data;

    if (!success) {
      return {
        cellPhone,
        error: error || 'Erro ao solicitar codigo',
      };
    }

    return {
      cellPhone,
      id: result?.id || null,
    };
  } catch (error) {
    throw error?.response?.data || error;
  }
};
